module.exports = __webpack_public_path__ + "static/wildflowers-botanical-coloring-page-b822c496e94b4b808b11514909a9b0f3.pdf";